import React from 'react';
import { FormattedMessage } from 'react-intl';
import MoreMeeting from '../meeting/MoreMeeting';
import { DatePicker, Spin } from 'antd';
import moment from 'moment';
import './RoomOccupyReport.less';
import { Axis, Chart, Geom, Legend, Tooltip } from 'bizcharts';
import DataSet from '@antv/data-set';
import { CHINESE, ENGLISH } from '../../utils/constants';

const { DataView } = DataSet;

export default ({ intl, dispatch, loading, roomOccupyReport = {} }) => {
  const {
    startTime,
    endTime,
    sTime,
    eTime,
    meetingTreeData,
    meetingSearchInfo,
    roomOccupyChartData,
    roomUseHotChartData,
    roomList,
    occTimeBlocks = []
  } = roomOccupyReport;
  const {
    moreMeeting = []
  } = meetingSearchInfo;
  const meetingTree = meetingTreeData || { child: [] };
  const startT = startTime;
  const endT = endTime;
  // 开始与结束时间天数只差
  const diffDays = endT.diff(startT, 'days');
  const dv = new DataView();
  dv.source(roomOccupyChartData).transform({
    type: 'sort-by',
    fields: ['rate'], // 根据指定的字段集进行排序，与lodash的sortBy行为一致
    order: 'ASC'        // 默认为 ASC，DESC 则为逆序
  });
  // 会议室占用情况高度
  let height_one = 400;
  let padding_one_bottom = 20;
  // 会议室使用时段热门指数高度
  let height_two = 400;
  // 计算会议室占用情况报表高度
  // 每10个会议室增加50px的高度
  height_one += (parseInt(Math.floor(roomList.length / 10) * 50));
  // 每10个会议室增加5%的padding, 50%为上限
  padding_one_bottom += (parseInt(Math.floor(roomList.length / 10) * 5));
  if(padding_one_bottom >= 50) padding_one_bottom = 50;
  // 会议室占用情况横坐标
  let array = [];
  for(let i = 0; i <= diffDays; i++) {
    array.push(i);
  }
  const cols = {
    day: {
      type: 'linear',
      alias: intl.formatMessage({id: "num_of_day"}),
      tickCount: diffDays,
      ticks: array,
      tickLine: {
        length: 1
      },
      formatter: val => {
        const start = moment(startTime);
        return start.add(val, 'days').format('MM-DD');
      }
    },

    rate: {
      range: [0, 1],
      alias: intl.formatMessage({id: "report_percent"}),
      tickCount: 11,
      formatter: (val) => `${(val * 100).toFixed(2)}%`,
      min: 0,
      max: 1
    },
    date: {
      type: 'linear',
      alias: intl.formatMessage({id: "report_date"}),
      tickCount: 31
    }
  };

  const ds = new DataSet();
  const hotUseDv = ds.createView().source(roomUseHotChartData);
  hotUseDv.transform({
    type: 'bin.histogram',
    field: 'quarterNumOfDay',
    binWidth: 1,
    as: ['value', 'count']
  });
  const hotUseCols = {
    value: {
      nice: false,
      tickInterval: 1,
      min: occTimeBlocks.length > 0 ? occTimeBlocks[0].quarterNumOfDay : 0,
      max: occTimeBlocks.length > 0 ? occTimeBlocks[occTimeBlocks.length - 1].quarterNumOfDay : 1,
      formatter: val => {
        const startTime = moment().startOf('day').add(parseInt(val) * 15, 'minutes');
        return startTime.format('HH:mm') + '~' + startTime.add(15, 'minutes').format('HH:mm');
      }
    }
  };
  return (
    <div className="message-body report-room report-container">
      <div className="room-occupy-container">
        {/*标题*/}
        {/*<div className="messages-first">
          <div className="nav">
            <a>{intl.formatMessage({ id: 'report_room_occupy_title' })}</a>
          </div>
        </div>*/}
        {/*主体*/}
        <Spin spinning={loading} size="large">
          {/*查询*/}
          <div className="messages-list roomReport room-report-title">
            <div className="messages-title roomReport-head room-occupy-report">
              <div className="report-div report-date">
                <label className="report-search-label" >
                  <FormattedMessage id="report_date"/>
                </label>
                <div>
                  <DatePicker
                    allowClear={false}
                    value={sTime}
                    disabledDate={current => {
                      return (
                        current.startOf('day').valueOf() > moment().startOf('day').valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'roomOccupyReport/setState',
                        payload: { sTime: e.startOf('day') }
                      });
                    }}
                  />
                  ~
                  <DatePicker
                    allowClear={false}
                    value={eTime}
                    disabledDate={current => {
                      return (
                        current.startOf('day').valueOf() > moment().startOf('day').valueOf()
                      );
                    }}
                    onChange={e => {
                      dispatch({
                        type: 'roomOccupyReport/setState',
                        payload: { eTime: e.endOf('day') }
                      });
                    }}
                  />
                </div>
              </div>
              <div className="report-div report-area">
                <label className="report-search-label">
                  <FormattedMessage id="report_area"/>
                </label>
                <div className="search-input">
                  <span className="menu-border">
                    <i className="iconfont icon-sousuo"/>
                    <MoreMeeting
                      meetingTree={meetingTree}
                      intl={intl}
                      placeHolder={intl.formatMessage({
                        id: 'report_room_place_holder'
                      })}
                      selected={moreMeeting}
                      onMeetingChange={v => {
                        dispatch({
                          type: 'roomOccupyReport/setState',
                          payload: {
                            meetingSearchInfo: {
                              ...meetingSearchInfo,
                              moreMeeting: v
                            }
                          }
                        });
                      }}
                    />
                  </span>
                </div>
              </div>
              <div className="report-div report-btn-group">
                <button className="button_primary"
                        onClick={() => {
                          dispatch({ type: 'roomOccupyReport/searchRoomOccupy', endTime: eTime, startTime: sTime });
                        }}>
                  <FormattedMessage id="report_search"/>
                </button>
                <button
                  onClick={() => {
                    dispatch({ type: 'roomOccupyReport/resetData' });
                  }}>
                  <FormattedMessage id="re_reset"/>
                </button>
              </div>
            </div>
          </div>

          <div className="occupy-content">
            <div className="occupy-char-one">
              <div className="char-tip">
                <FormattedMessage id="report_occupancy_detail"/>
              </div>
              <Chart height={height_one} padding={{top: '5%', right: '5%', bottom: padding_one_bottom + '%', left: '5%'}} data={dv} scale={cols} forceFit>
                <Legend/>
                <Axis name="day"/>
                <Axis name="rate"/>
                <Tooltip
                  showTitle={true}
                  title="day"
                  crosshairs={{
                    type: 'cross'
                  }}
                />
                <Geom
                  type="line"
                  position="day*rate"
                  size={1}
                  color={intl.locale ===ENGLISH?'roomNameEn':'roomName'}
                />
                <Geom
                  type="point"
                  position="day*rate"
                  size={3}
                  shape={'circle'}
                  color={intl.locale===ENGLISH?'roomNameEn':'roomName'}

                  style={{
                    stroke: '#fff',
                    lineWidth: 1
                  }}
                />
              </Chart>
            </div>
            <div className="occupy-char-two">
              <div className="char-tip">
                <FormattedMessage id="report_room_occupy_popular"/>
              </div>
              <Chart height={height_two} data={hotUseDv} scale={hotUseCols} forceFit>
                <Axis
                  name="value"
                  label={{
                    formatter: val => {
                      const time = val.split('~')[0];
                      if (moment(time, 'HH:mm').minute() === 0) {
                        return time;
                      } else {
                        return '';
                      }
                    }
                  }}
                />
                <Axis
                  name="count"
                />
                <Tooltip inPlot={false} crosshairs={false}/>
                <Geom type="interval" position="value*count"
                      tooltip={['value*count', (value, count) => {
                        return {
                          name: intl.formatMessage({ id: 'count' }),
                          value: count
                        };
                      }]}
                />
              </Chart>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/report/RoomOccupyReport.js